import { fromRichTextHtml } from '@wix/ricos';
import { RsvpStatus } from './constants';
import { getSerializableRichContent } from '../../ricos-editor/ricos-editor-utils';
export const getEventsHeaderContent = (rsvpStatus, goingContent, notGoingContent, waitlistContent) => {
  switch (rsvpStatus) {
    case RsvpStatus.NOT_GOING:
      return notGoingContent;
    case RsvpStatus.WAITLIST:
      return waitlistContent;
    case RsvpStatus.GOING:
    default:
      return goingContent;
  }
};
export const convertToRichContent = content => {
  return getSerializableRichContent(fromRichTextHtml(`<h1>${content}</h1>`));
};
//# sourceMappingURL=utils.js.map